import { BlockedRegionsConfig } from '../../donation/getDonationPartnerConfig/getDonationPartnerConfig.types'
import { toGsResponse } from '../../goodstack'
import { PartnerConfig } from '../../config/config.types'

import { QueryFn } from '@percent/workplace-giving/common/hooks/useQuery/useQuery.types'

export type GetPartnerRestrictedDonationConfigResponse = {
  data: {
    restricted_countries_for_donation?: PartnerConfig<
      'restricted_countries_for_donation',
      { blockedRegions: BlockedRegionsConfig[] }
    >
    allowlisted_countries_for_donation?: PartnerConfig<'allowlisted_countries_for_donation', { countryCodes: string[] }>
  }
  object: string
}

export type PartnerDonationRegionConfig = {
  blockedRegions: BlockedRegionsConfig[]
  allowlistedCountryCodes: string[]
}

export const getPartnerRestrictedDonationConfig: QueryFn<[string], PartnerDonationRegionConfig> = async (client, _) => {
  const response = await client
    .get<GetPartnerRestrictedDonationConfigResponse>(`v1/partner/donation/config`, {
      withCredentials: true,
      validateStatus: code => [200, 404].includes(code)
    })
    .then(r => toGsResponse(r.status, r.data))
    .then(r => (r.result === 'success' ? r : undefined))
    .catch(() => undefined)

  return {
    blockedRegions: response?.data.restricted_countries_for_donation?.value?.blockedRegions ?? [],
    allowlistedCountryCodes: response?.data.allowlisted_countries_for_donation?.value?.countryCodes ?? []
  }
}
